import { Avatar, Typography } from '@mui/material';
import useColorsStyles from 'common/colors';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
    avatar: {
        width: theme.spacing(4),
        height: theme.spacing(4),
        '& img ': {
            width: theme.spacing(2.25),
            height: theme.spacing(2.25),
            objectFit: 'inherit',
        },
        '&.big ': {
            width: theme.spacing(8),
            height: theme.spacing(8),
            '& img ': {
                width: theme.spacing(4),
                height: theme.spacing(4),
            },
        },
    },
}));

function stringToColor(string) {
    let hash = 0;
    let i;
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 5)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    return color;
}

const CustomAvatar = ({ icon, name, id, size = 'small' }) => {
    const { classes, cx } = useStyles();
    const { classes: colors } = useColorsStyles();

    let props;

    if (icon) {
        props = {
            src: icon,
        };
    } else {
        const [firstName, lastName] = (name || 'Unknown').trim().split(' ');
        let initials = '';
        if (firstName && lastName) {
            initials = `${firstName[0]}${lastName[0]}`;
        } else {
            initials = firstName.length < 3 ? firstName : firstName[0];
        }

        let variant = initials.length === 1 ? 'subtitle1' : 'subtitle2';
        if (size === 'big') {
            variant = initials.length === 1 ? 'onliveH3' : 'onliveH4';
        }

        props = {
            style: {
                background: stringToColor(id || firstName),
            },
            children: (
                <Typography className={colors.textWhite} variant={variant} textTransform="uppercase">
                    {initials}
                </Typography>
            ),
        };
    }
    return <Avatar alt="Icon" className={cx(classes.avatar, size)} {...props} />;
};

export default CustomAvatar;
